module.exports = __webpack_public_path__ + "img/shape_diamond.2fa5b0e6.png";